/**
 * #214 feature flag: the rail's Transport entry appears only while GET /api/transport/status
 * answers. This wraps the shell in the route manifest and calls `render` on every render, so
 * the shell (and its rail) re-renders the moment the probe settles — the rail reads the flag
 * through `visibleNavItems`, which never had to learn about transport.
 */
import type { ReactNode } from 'react';
import { setNavFeature } from '@/app/nav';
import { useAuth } from '@/auth/AuthProvider';
import { useTransportStatus } from './api';

export function TransportNavProbe({ render }: { render: () => ReactNode }) {
  const { signedIn, credentialAttached } = useAuth();
  const status = useTransportStatus(signedIn && credentialAttached);
  setNavFeature('transport', Boolean(status.data));
  return <>{render()}</>;
}
